import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SingleDataIntermittence } from 'types/dataIntermittenceDto';

import styles from './DataIntermittence.module.scss';
import { formatTimeLength } from '../ClosedRow/utils/dataIntermittence';

interface Props {
  dataIntermittence?: SingleDataIntermittence;
}

const DataIntermittence: React.FC<Props> = ({ dataIntermittence }) => {
  const intl = useIntl();

  if (!dataIntermittence) return <React.Fragment />;

  return (
    <>
      <div>
        <span className={dataIntermittence.max < 300 ? styles.validText : styles.warningText}>
          {formatTimeLength(dataIntermittence.max, intl)}
        </span>
        <FormattedMessage id="dataManagement.dataQuality.maxDataIntermittence" />
      </div>
      {`P50= `}
      <span
        className={dataIntermittence.p50 < 60 ? styles.validText : styles.warningText}
      >{`${formatTimeLength(dataIntermittence.p50, intl)}`}</span>
      {` & P90= `}
      <span className={dataIntermittence.p90 < 180 ? styles.validText : styles.warningText}>
        {formatTimeLength(dataIntermittence.p90, intl)}
      </span>
    </>
  );
};

export default DataIntermittence;
